import { j as f } from "./jsx-runtime-3tyXYecC.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { m as b } from "./tss-DN0acMKN.mjs";
import { M as v, d as y } from "./constants-CnFYFetN.mjs";
import { createContext as S, useContext as k } from "react";
import { D as j } from "./divider-Dq5lrAFK.mjs";
import { I as w } from "./icon-v2-DGtVEk7e.mjs";
import { L as D } from "./link-unstyled-CvXR-8s6.mjs";
const I = b()(({ mode: i, palette: r, spacing: n }) => ({
  root: {
    backgroundColor: e.ifFeature("encore", void 0, r.gray[100]),
    boxSizing: "border-box",
    display: e.ifFeature("encore", "flex", "block"),
    flexDirection: e.ifFeature("encore", "column"),
    gap: e.ifFeature("encore", n(0.25)),
    minHeight: "100%",
    outline: i === v.Dye ? `1px solid ${y.main}` : void 0,
    padding: e.ifFeature("encore", void 0, "14px 24px"),
    width: e.ifFeature("encore", 264, 262)
  }
})), L = b()(({ constructs: i, borderRadiuses: r, mode: n, palette: o, spacing: t, typography: u }, { active: m, compact: d, disabled: p }) => {
  const c = n === v.Dye ? y.main : o.primary.main;
  let a = o.gray[800], s, h, g, x = o.common.white, l = c;
  return e.ifFeature("encore", !0) ? p ? (a = o.gray[600], x = "unset", l = o.gray[600], s = "default") : m ? (a = o.common.white, s = "default", h = c, g = u.fontWeightBold, x = c, l = o.common.white) : x = i.surface.neutral.inverted : m && (a = c, g = "800"), {
    root: {
      alignItems: "center",
      backgroundColor: h,
      border: "none",
      borderRadius: e.ifFeature("encore", r[200], "2px"),
      boxSizing: "border-box",
      color: a,
      cursor: s,
      display: "flex",
      fill: a,
      fontWeight: g,
      gap: e.ifFeature("encore", t(d ? 1 : 1.5), "8px"),
      marginLeft: "0",
      overflowWrap: "anywhere",
      padding: e.ifFeature("encore", d ? t(1, 1.5) : t(1.5, 2), "9px 10px"),
      textIndent: "0",
      "&:hover": {
        backgroundColor: x,
        borderRadius: e.ifFeature("encore", r[200], "4px"),
        color: l,
        fill: l,
        textDecoration: "none"
      },
      ...e.ifFeature(
        "encore",
        {
          "&:focus-visible": {
            borderRadius: r[200],
            boxShadow: `0 0 0 2px color-mix(in srgb, ${i.surface.primary.medium} 80%, transparent)`,
            color: l,
            fill: l
          }
        },
        {}
      )
    },
    // @startCleanup encore
    icon: e.ifFeature(
      "encore",
      {},
      {
        boxSizing: "border-box",
        display: "inline-flex",
        flexDirection: "column",
        height: "22px",
        justifyContent: "center",
        width: "20px"
      }
    )
    // @endCleanup encore
  };
}), F = S({
  compact: !1
});
function N(i) {
  const { active: r, activeIcon: n, children: o, component: t = "a", disabled: u = !1, icon: m, href: d, ...p } = i, { compact: c } = k(F), { classes: a } = L({ active: r, compact: c, disabled: u }), s = r && n ? n : m;
  return /* @__PURE__ */ f.jsxs(D, { className: a.root, component: t, href: d && !u ? d : void 0, ...p, children: [
    e.ifFeature(
      "encore",
      typeof s == "string" ? /* @__PURE__ */ f.jsx(w, { name: s, size: c ? 16 : 20 }) : null,
      /* @__PURE__ */ f.jsx("div", { className: a.icon, children: s })
    ),
    o
  ] });
}
const z = () => /* @__PURE__ */ f.jsx(
  j,
  {
    color: e.ifFeature("encore", "neutral-weak"),
    light: e.ifFeature("encore", void 0, !0),
    margin: e.ifFeature("encore", 1.5)
  }
);
function C(i) {
  const { ariaLabel: r, items: n, compact: o = !1 } = i, { classes: t } = I();
  return /* @__PURE__ */ f.jsx(F.Provider, { value: { compact: o }, children: /* @__PURE__ */ f.jsx("nav", { "aria-label": r, className: t.root, "data-fabric-component": "SideNavigation", children: n }) });
}
C.Divider = z;
C.Link = N;
export {
  C as S
};
//# sourceMappingURL=side-navigation-aQhR7XmC.mjs.map
